import React from "react";
import { Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import IconCircle from "../shared/IconCircle";
import { cardDescSx, cardTitleSx, COLORS, CONTENT_MAX_WIDTH, FONT, textFieldSx } from "../shared/styles";
import { EmailIcon } from "./icons";

function LinkEmailInfoCard({
  previewText,
  emailInput,
  onEmailChange,
  onLink,
  linkDisabled,
  inputDisabled,
  saveLoading,
  showInput,
}) {
  return (
    <Box
      sx={{
        mt: "32px",
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        minHeight: "160px",
        p: "16px",
        borderRadius: "8px",
        border: `1px solid ${COLORS.primary}`,
        bgcolor: "#F3FBFF",
        boxShadow: "0 1px 2px 0 rgba(20, 141, 253, 0.1)",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
        <IconCircle bgcolor="#D6EDFF">
          <EmailIcon />
        </IconCircle>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography component="p" sx={cardTitleSx}>
            How Email Linking Works
          </Typography>
          <Typography component="p" sx={{ ...cardDescSx, mt: "4px", lineHeight: "24px" }}>
            When you link your personal company email, your outbound ticket replies will appear as:
          </Typography>

          <Box
            sx={{
              mt: "16px",
              width: "100%",
              height: "40px",
              px: "12px",
              display: "flex",
              alignItems: "center",
              borderRadius: "8px",
              border: "1px solid #D6EDFF",
              bgcolor: "#FAFDFF",
              color: COLORS.textSecondary,
              fontFamily: FONT.family,
              fontSize: "14px",
              fontWeight: 400,
              boxSizing: "border-box",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {previewText}
          </Box>

          {showInput ? (
            <>
              <TextField
                type="email"
                placeholder="e.g. angela@company.com"
                value={emailInput}
                onChange={(e) => onEmailChange(e.target.value)}
                disabled={inputDisabled}
                fullWidth
                sx={{
                  ...textFieldSx,
                  mt: "12px",
                  "& .MuiOutlinedInput-root.Mui-disabled": {
                    bgcolor: COLORS.backgroundLight,
                  },
                }}
              />
              <Button
                onClick={onLink}
                disabled={linkDisabled}
                variant="contained"
                disableElevation
                sx={{
                  mt: "12px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "120px",
                  height: "36px",
                  px: "16px",
                  borderRadius: "8px",
                  bgcolor: COLORS.primary,
                  backgroundColor: COLORS.primary,
                  color: COLORS.white,
                  fontFamily: FONT.family,
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  textTransform: "none",
                  boxShadow: COLORS.shadow,
                  "&:hover": {
                    bgcolor: "#127EDE",
                    backgroundColor: "#127EDE",
                    boxShadow: COLORS.shadow,
                  },
                  "&:disabled": { opacity: 0.6 },
                }}
              >
                {saveLoading ? (
                  <CircularProgress size={18} sx={{ color: COLORS.white }} />
                ) : (
                  "Link Email"
                )}
              </Button>
            </>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}

export default LinkEmailInfoCard;
